import { useCallback } from 'react';

import { useDocumentVisibilityDetection } from '@spotify/confidence-core-react';

type UseEmailVerificationOptions = {
  getAccessTokenSilently: (opts: {
    cacheMode: 'on' | 'off' | 'cache-only';
  }) => Promise<string>;
  isAuthenticated: boolean;
  isEmailVerified: boolean;
};

export const useEmailVerification = ({
  getAccessTokenSilently,
  isAuthenticated,
  isEmailVerified,
}: UseEmailVerificationOptions) => {
  const recheckEmailVerification = useCallback(() => {
    getAccessTokenSilently({ cacheMode: 'off' }).catch(() => {});
  }, [getAccessTokenSilently]);

  const handleVisibilityChange = useCallback(
    (isVisible: boolean) => {
      if (!isVisible || !isAuthenticated || isEmailVerified) return;
      recheckEmailVerification();
    },
    [isAuthenticated, isEmailVerified, recheckEmailVerification],
  );
  useDocumentVisibilityDetection(handleVisibilityChange);

  return { recheckEmailVerification };
};
